

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface ProcedureParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface Procedure {
   
    name: string;
    price: number;
    code:string;
    id?: any;
    tenantId: any;
    branchId: any;
    
  parameters?: ProcedureParameter[];
  links?: any;
}

export abstract class ProcedureData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<Procedure[]>;
  abstract create(url: string, data: Procedure): Observable<Procedure[]>;
  abstract update(url: string, data: Procedure): Observable<Procedure>;
  abstract delete(url: string): Observable<any>;
}
